module.exports = __webpack_public_path__ + "static/media/backgroundCoupon.bdeb2b7b.png";